import { t } from "react-switch-lang";
import InputText from "../FormFields/InputText";
import Trash from "../../../src/app/IncurredRisk/img/Trash.svg";
import React, { useState } from "react";
import Toast from "../toast/Toast";
import DownloadOutlined from "@ant-design/icons/lib/icons/DownloadOutlined";
import './FileUploadSection.scss'
import {Spinner} from 'react-bootstrap';

const FileUploadSection = ({
                               disabled = false,
                               allowedFileTypes = null,
                               fetchedFiles = [],
                               onDeleteFetchedFile = () => {},
                               onNewFilesChange = () => {},
                                onFileDownload = () => {},
                                multiple = true,
                                showLocalFiles = true,
                                className,
                                // required = false,
                             fieldName,
                             setValue,
                             register,
                             error,
                                maxFiles = null,
                             isUploading = false,
                           }) => {
    const [localFiles, setLocalFiles] = useState([]);
  // fetchedFiles (array or single object)
  const normalizedFetchedFiles = Array.isArray(fetchedFiles)
    ? fetchedFiles.filter(file => file && file.id && file.fileName)
    : fetchedFiles && fetchedFiles.id
      ? [fetchedFiles]
      : [];
    const uploadOnChange = () => {
        const input = document.getElementById(fieldName ? `upload-${fieldName}` : 'upload');
        let children = [];

      const selectedFiles = Array.from(input.files);
      const totalFilesCount = selectedFiles.length + normalizedFetchedFiles.length + localFiles.length;

      if (maxFiles && totalFilesCount > maxFiles) {
        Toast.fire({
          title: t("message.maxFiles", {
            entity: maxFiles,
          }),
          icon: "error",
        });
        input.value = "";
        return;
      }
        for (let i = 0; i < input.files.length; ++i) {
            const file = input.files.item(i);

            if (allowedFileTypes) {
                const allowedTypesArray = allowedFileTypes.split(",");
                const fileExtension = file.name
                    .substring(file.name.lastIndexOf("."))
                    .toLowerCase();

                if (!allowedTypesArray.includes(fileExtension)) {
                    Toast.fire({
                        title: t("message.fileTypeNotAllowed", { entity: file.name }),
                        icon: "error",
                    });
                }
            }

            if (file.size > 10485760) {
                Toast.fire({
                    title: t("message.fileTooBig"),
                    icon: "error",
                });
                continue
            } else {
                children.push({ id: file.name, label: file.name });
            }
        }

        setLocalFiles(children);
        onNewFilesChange(children);
    };

    const clearLocalFile = (index) => {
        const dt = new DataTransfer();
        const input = document.getElementById(fieldName ? `upload-${fieldName}` : 'upload');
        const { files } = input;
        let children = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (index !== i) {
                dt.items.add(file);
                children.push({
                    id: file.name,
                    label: file.name,
                });
            }
        }

        input.files = dt.files;
        setLocalFiles(children);
        onNewFilesChange(children);
    };

    return (
        <div className={className}>
            {/*{!required && <span className="optional register">{t("common.optional")}</span>}*/}
          {(!maxFiles || (fetchedFiles.length + localFiles.length < maxFiles)) && (
            <InputText
                id= {fieldName ? `upload-${fieldName}` : 'upload'}
                type="file"
                name="file"
                multiple={multiple}
                className="file-input"
                onChange={!isUploading ? uploadOnChange : undefined}
                disabled={disabled}
                accept={allowedFileTypes}
                ref={register}
            />)}
          {isUploading && (
            <div className="text-center mt-4 mb-4">
              <Spinner animation="border" role="status" />
            </div>
          )}
            {/* Fetched files (edit mode) */}
          {normalizedFetchedFiles?.length > 0 && (
            <ul>
              {normalizedFetchedFiles.map((file) => {
                const isDownloadMode = disabled;
                return (
                  <li
                    key={`${file.id}-${file.fileName}`}
                    style={{ cursor: isDownloadMode ? "pointer" : "default" }}
                    onClick={() => {
                      if (isDownloadMode) onFileDownload(file?.id, file?.fileName);
                    }}
                  >
                    <div className="d-flex align-items-center">
            <span
              style={{
                maxWidth: "23rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              className="mr-2"
              title={file?.fileName}
            >
              {file?.fileName}
            </span>

                      {disabled ? (
                        maxFiles ? (
                          <img
                            src={"/images/download.svg"}
                            style={{ cursor: "pointer" }}
                            alt="download"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              onFileDownload(file?.id, file?.fileName);
                            }}
                          />
                        ) : (
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              onFileDownload(file?.id, file?.fileName);
                            }}
                          >
                  <DownloadOutlined />
                </span>
                        )
                      ) : (
                        <img
                          src={Trash}
                          alt="trash"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onDeleteFetchedFile(file.id);
                          }}
                        />
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}


          {/* Local (newly added) files */}
            {(localFiles.length > 0 && showLocalFiles) && (
                <ul>
                    {localFiles.map((file, index) => (
                        <li key={file.id}>
                            <div className="d-flex align-items-center">
                                <span className="mr-2">{file.label}</span>
                                {!disabled && (
                                    <img
                                        src={Trash}
                                        alt="trash"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            clearLocalFile(index);
                                        }}
                                    />
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
            {error && <p className="error-message">{error}</p>}
        </div>
    );
};

export default FileUploadSection;